export var EProductAttributeType;
(function (EProductAttributeType) {
    EProductAttributeType["STRING"] = "STRING";
    EProductAttributeType["NUMBER"] = "NUMBER";
    EProductAttributeType["BOOLEAN"] = "BOOLEAN";
    EProductAttributeType["DATE"] = "DATE";
    EProductAttributeType["SELECT"] = "SELECT";
    EProductAttributeType["IMAGE_SELECT"] = "IMAGE_SELECT";
    EProductAttributeType["MULTISELECT"] = "MULTISELECT";
    EProductAttributeType["TEMPLATE"] = "TEMPLATE";
})(EProductAttributeType || (EProductAttributeType = {}));
